import { validateVerificationCodeRoute } from "../../../../ApiRoutes";

export const otpValidate = (
    setErrorMessage: (errorMessage: string) => void,
    smsCode: string,
    otpUuid?: string
): Promise<{ valid: boolean } | undefined> =>
    fetch(validateVerificationCodeRoute(otpUuid), {
        body: JSON.stringify({ otp: `${smsCode}` }),
        headers: { "Content-Type": "application/json" },
        method: "POST",
    })
        .then((response) => response.json())
        .then((result) => {
            if (result?.errorMessage) {
                setErrorMessage(result.errorMessage);

                return undefined;
            }

            return result;
        });
